import React from 'react';
import {useTranslation} from 'react-i18next';
import {SelectInput, TscThemeName, TscThemeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';
import styled from 'styled-components';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {SortMetric} from '../../constants/Constants';
import {setSortMetric, sortMetricStore} from '../../service/sortMetricProvider';
import {useTscTheme} from '../../context/themeProvider';

const SortDirectionWrapper = styled.div<{theme: TscThemeNames}>`
   & div {
      display: flex;
      align-items: center;
      color: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.text.light : TscStyles.color.text.dark};

      label {
         margin-right: 0.5rem;
         margin-bottom: 0;
      }
   }

   select {
      font-size: 0.875rem;
      line-height: 1.4;
   }
`;

export const SortDirectionOptionsBase: React.FC<IStateMappedProps> = ({sortMetric}) => {
   const {t} = useTranslation();
   const theme = useTscTheme();

   const updateSortOption = (evt: React.ChangeEvent<HTMLSelectElement>): void => {
      const newSortMetric = evt.target.value as SortMetric;
      setSortMetric(newSortMetric);
   };

   const sortOptions = [
      {value: SortMetric.dateAscending, label: t('sortOptions.date.ascending.label'), title: t('sortOptions.date.ascending.title')},
      {value: SortMetric.dateDescending, label: t('sortOptions.date.descending.label'), title: t('sortOptions.date.descending.title')},
      {value: SortMetric.titleAscending, label: t('sortOptions.title.ascending.label'), title: t('sortOptions.title.ascending.title')},
      {value: SortMetric.titleDescending, label: t('sortOptions.title.descending.label'), title: t('sortOptions.title.descending.title')},
      {value: SortMetric.viewsAscending, label: t('sortOptions.views.ascending.label'), title: t('sortOptions.views.ascending.title')},
      {value: SortMetric.viewsDescending, label: t('sortOptions.views.descending.label'), title: t('sortOptions.views.descending.title')}
   ];

   return (
      <SortDirectionWrapper data-test-id="sort-direction-wrapper">
         <SelectInput
            label={t('sortOptions.label')}
            value={sortMetric}
            options={sortOptions}
            onChange={updateSortOption}
            themeName={theme}
            isFullWidth={false}
         />
      </SortDirectionWrapper>
   );
};

export interface IStateMappedProps {
   sortMetric: SortMetric;
}

const mapStatesToProps = (
   // eslint-disable-next-line no-empty-pattern
   {},
   {sortMetric}: Partial<IStateMappedProps>
): IStateMappedProps => ({sortMetric});

export default withMemoizedContexts(mapStatesToProps, sortMetricStore)(SortDirectionOptionsBase);
